import { api } from "@/lib/axios";
import { User } from "@/types/user";

const forgotPassword = (email: string): Promise<User> =>
  api
    .post(`/auth/forgot-password`, { email })
    .catch(() => ({})) as Promise<User>;

export default forgotPassword;
